document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("powerupForm");
  const results = document.getElementById("results");
  if (!form || !results) return;

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    const sex = document.getElementById("sex").value;
    const age = +document.getElementById("age").value;
    const weight = +document.getElementById("weight").value;
    const height = +document.getElementById("height").value;
    const activity = +document.getElementById("activity").value;
    const goal = document.getElementById("goal").value;

    let tmb =
      sex === "male"
        ? 10 * weight + 6.25 * height - 5 * age + 5
        : 10 * weight + 6.25 * height - 5 * age - 161;

    let tdee = tmb * activity;

    let calories = tdee;
    let proteinFactor = 1.4;
    let message = "";
    let ctaLink = "/collections/all";

    switch (goal) {
      case "muscle":
        calories = tdee * 1.15;
        proteinFactor = 2.0;
        message =
          "💥 Estás listo para construir músculo. Sube calorías con estrategia y proteína constante.";
        ctaLink = "/collections/muscle";
        break;

      case "fat":
        calories = tdee * 0.8;
        proteinFactor = 2.3;
        message =
          "🔥 Modo definición activado. Mantén el déficit y prioriza fuerza + proteína alta.";
        ctaLink = "/collections/fat-burn";
        break;

      case "weightloss":
        calories = tdee * 0.75;
        proteinFactor = 2.2;
        message =
          "⬇️ Pierde grasa sin sacrificar músculo: constancia, proteína y movimiento diario.";
        ctaLink = "/collections/weight-loss";
        break;

      case "maintain":
        calories = tdee;
        proteinFactor = 1.6;
        message =
          "⚖️ Estás en equilibrio. Mantén hábitos limpios para sostener energía y rendimiento.";
        ctaLink = "/collections/maintain";
        break;

      case "health":
        calories = tdee;
        proteinFactor = 1.3;
        message =
          "🌱 Nutrición consciente: alimentos reales, descanso y suplementación inteligente.";
        ctaLink = "/collections/health";
        break;
    }

    const protein = weight * proteinFactor;

    results.innerHTML = `
      <div class="card">
        <h2>Resultados Power Up ⚡</h2>
        <p><strong>Calorías diarias:</strong> ${Math.round(calories)} kcal</p>
        <p><strong>Proteína recomendada:</strong> ${Math.round(protein)} g/día</p>
        <p class="powerup-msg">${message}</p>
        <a class="button button--primary" href="${ctaLink}">
          Ver productos recomendados para mí
        </a>
      </div>
    `;

    results.style.display = "block";
    results.scrollIntoView({ behavior: "smooth", block: "start" });
  });
});
